<h2 mat-dialog-title>Make {{ user.name }} an admin?</h2>

<mat-dialog-content>
  This user will be able to add and remove users and edit spaces. The user will
  also be able to add and remove admins, including yourself.
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="accept()">
    Make admin
  </button>
</mat-dialog-actions>
